import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NutritionCoachingType, NutritionTrackingType, MacroTargetsType } from '@cf-shared/data-model/user-state';

import { LL } from 'i18n/i18n.service';
/** Minimal interface for state objects passed to this component */
interface NutritionOptionsState {
  nutritionCoaching?: NutritionCoachingType;
  nutritionTracking?: NutritionTrackingType;
  macroTargets?: MacroTargetsType;
  advancedMethodsCalorieCycling?: boolean;
}

@Component({
  selector: 'nutrition-options-component',
  templateUrl: 'nutrition-options-component.html',
  host: { 'class': 'nutrition-options-component' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NutritionOptionsComponent {
  protected LL = LL;
  @Input() state: NutritionOptionsState;
  @Output() change = new EventEmitter<void>();

  // Computed boolean properties for radio group bindings
  get nutritionCoachingOn(): boolean {
    return this.state.nutritionCoaching !== NutritionCoachingType.None;
  }
  set nutritionCoachingOn(value: boolean) {
    this.state.nutritionCoaching = value ? NutritionCoachingType.Default : NutritionCoachingType.None;
  }

  get nutritionTrackingOn(): boolean {
    return this.state.nutritionTracking !== NutritionTrackingType.None;
  }
  set nutritionTrackingOn(value: boolean) {
    this.state.nutritionTracking = value ? NutritionTrackingType.Default : NutritionTrackingType.None;
  }

  get macroTargetsFlexible(): boolean {
    return this.state.macroTargets === MacroTargetsType.Flexible;
  }
  set macroTargetsFlexible(value: boolean) {
    this.state.macroTargets = value ? MacroTargetsType.Flexible : MacroTargetsType.Exact;
  }

  handleNutritionToggleChanged() {
    this.change.emit();
  }

  handleCalorieCyclingChange() {
    this.change.emit();
  }
}
